import React, { useState } from 'react';
import { arrayOf, shape } from 'prop-types';

// components
import MyAuthCard from './MyAuthCard';

const CardsList = ({ cards, viewBy }) => {
  const [cardHeight, setCardHeight] = useState(323);
  return cards.map((card, index) => (
    <MyAuthCard
      card={card}
      cardHeight={cardHeight}
      index={index}
      key={card.productAuthorizationId}
      setCardHeight={setCardHeight}
      viewBy={viewBy}
    />
  ));
};

CardsList.propTypes = {
  cards: arrayOf(shape()),
};

CardsList.defaultProps = {
  cards: [],
};

export default CardsList;
